<template>
	<div>
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: 'guest',
	};
</script>


// WEBPACK FOOTER //
// Guest.vue?a0cc7e3e